import styled, { css } from 'styled-components';

import mixin from '../../_foundations/Mixin';

const Card = styled.div`
  ${({
    color = 'neutral',
    padding = '0.75rem',
    borderRadius = 300,
    elevation = 0,
  }) => css`
    background-color: var(--${color}-${color === 'neutral' ? 10 : 100});
    background-clip: border-box;
    border: 1px solid var(--${color}-${color === 'neutral' ? 200 : 400});
    padding: ${padding};
    ${mixin.borderRadius({ size: borderRadius })}
    ${mixin.elevation(elevation)}
  `}
`;

export default Card;
